<template>
  <div>
    <nav-header
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread ref="child" @indexPCR="p_showLoginModal"></nav-bread>
    <div class="card">
      <div
        v-for="(item, index) in allList"
        @click="toDetail(item)"
        :key="index"
      >
        <template v-if="item.type === 1">
          <img class="video_play" src="../assets/icon_video_play.png" />
          <img
            class="card_pic"
            :src="item.videoUrl[0] + '?vframe/jpg/offset/1'"
          />
        </template>
        <template v-else>
          <img class="card_pic" :src="item.imgsUrl[0]" />
        </template>
        <div class="card_content">
          <div class="card_title">{{ item.title }}</div>
          <div class="card_user">
            <div class="user_left">
              <img
                v-if="item.pic && item.pic !== '/images/mine_deep.png'"
                :src="item.pic"
              />
              <img v-else src="../assets/user_pic_default.png" />
              <span>{{ item.name }}</span>
            </div>
            <div class="user_right">
              <img
                v-if="item.isLike"
                src="../assets/icon_love_active.png"
                @click.stop="deleteLove(item)"
              />
              <img
                v-else
                src="../assets/icon_love.png"
                @click.stop="handleLove(item)"
              />
              <span v-if="item.likeNum">{{ item.likeNum }}</span>
            </div>
          </div>
        </div>
      </div>
      <van-loading size="24px" v-if="loading">加载中...</van-loading>
      <div class="icon_empty" v-if="!allList.length">
        <img src="../assets/icon_works_empty2.png" />
      </div>
    </div>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
import NavHeader from "@/components/Header.vue";
import NavBread from "@/components/Bread.vue";
import NavFooter from "@/components/Footer.vue";
import axios from "axios";

export default {
  name: "kp",
  data() {
    return {
      p_showSearch: true,
      p_loginModalFlag: false,
      allList: [],
      loading: false
    };
  },
  components: {
    NavHeader,
    NavFooter,
    NavBread
  },
  mounted() {
    this.loadMoreHealth();
  },
  methods: {
    p_showLoginModal() {
      this.p_loginModalFlag = true;
    },
    p_closeLoginModal() {
      this.p_loginModalFlag = false;
    },
    loadMoreHealth() {
      this.allList = [];
      this.loading = true;
      let params = {
        current: 1,
        size: 200
      };
      axios
        .get("/video/work/tip/page", {
          params: params
        })
        .then(res => {
          if (res.data.code === 0) {
            let list = res.data.result.records.filter(v => !v.type);
            if (list.length) {
              list.map((item, index, array) => {
                item.imgsUrl = JSON.parse(item.imgsUrl);
                item.videoUrl = JSON.parse(item.videoUrl);
              });
              this.allList = this.allList.concat(list);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toDetail(e) {
      let { type, id } = e;
      let navType = "";
      this.$router.push({
        name: type ? "VideoMain" : "ArticleMain",
        query: { id, navType }
      });
    }
  }
};
</script>

<style scoped>
.card {
  width: 70%;
  margin: 30px auto;
  padding: 0px 3px 100px 3px;
  background-color: #f4f4f4;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); /* 自适应列数 */
  gap: 30px; /* 列间距 */
}

.video_play {
  position: absolute;
  width: 25px;
  height: 25px;
  top: 6px;
  right: 6px;
  z-index: 100;
}

.card_pic {
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.card_content {
  padding: 10px;
}

.card_title {
  color: #050505;
  font-size: 14px;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.card_user {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #5a5b5c;
}

.card_user * {
  display: inline-block;
  vertical-align: middle;
}

.user_left {
  width: calc(100% - 60px);
}

.user_left span {
  width: calc(100% - 25px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.user_left img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.user_right img {
  width: 15px;
  height: 13px;
}

.icon_empty {
  text-align: center;
  margin-top: 25px;
}

.icon_empty img {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/KP.vue